import { dataRow } from './../../../booking/list-member/list-member.service';
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Rx';
import { BaseService } from '../../../../shared/services/base.service';
import { DialogService } from '../../../../shared/services/dialog.service';
import { ValidationService } from '../../../../shared/services/validation.service';
import { Utility } from '../../../../common/utility';
import { AppMessages } from '../../../../shared/constants/messages';
import { AppConstants } from '../.././../../shared/constants/constants';
import { Page } from '../../../../models/list/page.model';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { UserUrl } from '../../../../shared/urls/user.url';

import { InvoiceListModel } from '../../../../models/payment/invoice.model';
import { PaymentModel } from '../../../../models/payment/payment.model';
import { AccountPaymentService } from '../account-payment.service';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'pay-invoice',
  templateUrl: './pay-invoice.component.html',
  providers: [AccountPaymentService]
})

export class PayInvoiceComponent implements OnInit {
  @Input() listinvoice;
  public appConstants = AppConstants;
  public paymentForm: FormGroup;
  public paymentFormTax: FormGroup;
  public type: string;
  public dataCalculate = {
    totalBalance: 0,
    current: 0,
    days: 0,
    overdue: 0
  };
  public selectedCurrency: any = {
    code: '',
    id: '',
    symbol: '',
    symbolPosition: '',
    rate: 1
  };
  public paymentModel = new PaymentModel();
  public listPaymentType: any[];

  constructor(private formBuilder: FormBuilder,
              public utility: Utility,
              public baseService: BaseService,
              public dialogService: DialogService,
              public accountPaymentService: AccountPaymentService) {
    this.createForm();

  }

  ngOnInit() {
    this.setPage({offset: 0});

    this.accountPaymentService.getPaymentType().subscribe(
      result => {
        if (result) {
          this.listPaymentType = result.json();
        }
      }
    );
  }

  createForm() {
    this.paymentForm = this.formBuilder.group({
      total: 0,
      type: ['', [Validators.required]],
      value: ['', [Validators.required]],
    });

    this.paymentFormTax = this.formBuilder.group({
      total: 0,
    });

  }

  /**
   * Populate the table with new data based on the page number
   * @param page The page to select
   */
  setPage(pageInfo) {
    if (!pageInfo) {
      return;
    }
  }
  
 checkIsPaidForInvoices(){   
   var invPaid = "";
   this.listinvoice.dataChecked.forEach(element => {
    if ( element['amountOpen'] === 0 && element['paid'] === true ) {
      invPaid+= element['InvoiceNo'] + ",";
    } 
  });
  return invPaid;
 }
  /**
   * Pay the Amount Open of the selected invoice
   */
  onPay() {
    if (this.paymentForm.valid && this.paymentForm.dirty) {
      //if (this.listinvoice.dataChecked.length === 1) {
        // check invoice full paid
        var invPaid = this.checkIsPaidForInvoices();
        if(this.checkIsPaidForInvoices().length > 0)
        {
          this.dialogService.openErrorDialog({ message: AppMessages.payment.errorInvoicePaid});
        }
        else {
          var totalAmountOpen = 0;
          this.listinvoice.dataChecked.forEach(element => {
            totalAmountOpen += element['amountOpen'];
          });

          if(((this.paymentForm.controls['value'].value > totalAmountOpen || this.paymentForm.controls['value'].value < totalAmountOpen) 
              && this.listinvoice.dataChecked.length > 1 ) // if pay multi invoices, user need to input enough money to paid
          || (this.paymentForm.controls['value'].value > totalAmountOpen && this.listinvoice.dataChecked.length === 1)) {
            this.dialogService.openErrorDialog({ message: AppMessages.payment.errorOverPay});
          } else
          {
          this.listinvoice.dataChecked.forEach(element => {
              const param = {
              invoiceId: element['id'],
              amountOpen: element['amountOpen'],
              paymentType: this.paymentForm.controls['type'].value,
              value: (this.listinvoice.dataChecked.length === 1? this.paymentForm.controls['value'].value : element['amountOpen']),
              currencyCode: this.listinvoice.filterData.currency
            };

          this.accountPaymentService.payInvoice(param).subscribe(
            result => {
              if (result) {
                this.dialogService.openSuccessDialog({ message: AppMessages.payment.successPay});
                this.listinvoice.setPage({offset: 0});
              }
            }
          );
            });
          }
        }
     // } else {
      //  this.dialogService.openErrorDialog({ message: AppMessages.payment.errorPay });
      //}
    }
  }

  onPayTax() {
    if (this.listinvoice.dataChecked.length > 0) {
      this.accountPaymentService.receivedTax(this.listinvoice.dataChecked.map(item => item.id)).subscribe(
        result => {
          if (result) {
           this.listinvoice.setPage({offset: 0});
          }
        }
      );
    } else {
      this.dialogService.openErrorDialog({ message: AppMessages.payment.errorPay });
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/payment/account-payment/pay-invoice/pay-invoice.component.ts